// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const HomePage: MarkdocTagRegistration = {
  tag: 'home-page',
  component: 'HomePage',
  attributes: {
    showCorporateCard: {
      type: Boolean,
      default: false,
      description: `Whether to show information about Corporate Card`,
    },
  },
};
